import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Divider — central horizontal rule flanked by two short ticks
 *  staggered above-left / below-right. Reads as "horizontal
 *  separator" without looking like a mathematical minus or a
 *  hairline-only `<hr>`. */
export function IcnDivider(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="divider">
      <line x1="2" y1="8" x2="14" y2="8" />
      <line x1="2" y1="4" x2="6" y2="4" />
      <line x1="10" y1="12" x2="14" y2="12" />
    </Svg>
  );
}
